import Promise from "bluebird";
import moment from "moment";
import React from 'react';

import config from "../../../server/src/config";

export const isDefined = val => typeof(val) !== 'undefined';
export const undefinedToNull = val => typeof(val) === 'undefined' ? null : val;
export const nullToZero = val => val === null ? 0 : val;
export const nullToBlank = val => val === null ? '' : val;
export const nullToHtmlBlank = val => val === null ? <span>&nbsp;</span> : val;
export const nullAndZeroToFalse = val => val !== null && val !== 0;
export const zeroToNull = val => val === 0 ? null : val;
export const blankToNull = val => val === '' ? null : val;
export const isSet = (obj, prop) => typeof(obj[prop]) !== 'undefined';
export const isSetAndTrue = (prop) => typeof(prop) !== 'undefined' && prop;

export const currentWeek = () => {
    const now = new Date();
    const week = moment(now).isoWeekday() > 3 ? moment(now).isoWeek() : moment(now).isoWeek() - 1;
    return week;
};

export const getRegi = (kfk) => {
    if (!/^[0-9]{2}/.test(kfk)) return null;
    if (kfk >= '97' || kfk < '88') return 'Privat';
    if (kfk >= '95' && kfk < '97') return 'Sektion';
    return 'DdB';
};

// Scan all properties with a specified prefix of an object.
export const scanProps = (obj, prefix, cb) => {
    for (const propName in obj) {
        if (obj.hasOwnProperty(propName) && propName.substr(0, prefix.length) === prefix) cb(obj[propName], propName);
    }
};
export const scanPropsAsync = async (obj, prefix, cb) => {
    const props = [];
    for (const propName in obj) {
        if (obj.hasOwnProperty(propName) && propName.substr(0, prefix.length) === prefix) props.push({
            name: propName,
            value: obj[propName],
        });
    }
    await Promise.all(props.map(async prop => {
        await cb(prop.value, prop.name);
    }));
};

// Create a simple list of numbers (n1-nx replaced n1, n2... nx) from a compressed list.
export const SimpleList = (txt, allowDuplicates = true, validateItem = null, allowRanges = true) => {
    const result = [];
    let isErrors = false;
    if (txt !== null && txt.trim() !== '') {
        const items = txt.split(',');
        items.forEach(item => {
            const endPoints = item.split('-');
            switch (endPoints.length) {
                case 1:
                    const n = item.trim();
                    if (/^[0-9]+$/.test(n)) {
                        if (!allowDuplicates && result.indexOf(n) >= 0) isErrors = true;
                        else if (validateItem !== null && !validateItem(n)) isErrors = true;
                        else result.push(n);
                    } else isErrors = true;
                    break;
                case 2:
                    if (allowRanges) {
                        const n1 = endPoints[0].trim();
                        const n2 = endPoints[1].trim();
                        if (/^[0-9]+$/.test(n1) && /^[0-9]+$/.test(n2)) {
                            if (Number(n1) > Number(n2)) isErrors = true;
                            else for (let n = Number(n1); n <= Number(n2); n++) {
                                if (!allowDuplicates && result.indexOf(String(n)) >= 0) isErrors = true;
                                else if (validateItem !== null && !validateItem(String(n))) isErrors = true;
                                else result.push(String(n));
                            }
                        } else isErrors = true;
                    } else isErrors = true;
                    break;
                default:
                    isErrors = true;
            }
        });
    }
    return {
        items: result.sort((n1, n2) => Number(n1) - Number(n2)),
        isErrors: isErrors,
    }
};

// Create a compressed list (n1, n2... nx replaced by n1-nx) from a simple list of numbers.
export const CompressList = (txt) => {
    const result = [];
    let isErrors = false;
    if (txt !== null && txt.trim() !== '') {
        const items = txt.split(',').map(item => item.trim());
        if (items.findIndex(item => !/^[0-9]+$/.test(item)) >= 0) isErrors = true;
        else {
            let n1 = null;
            items.sort((n1, n2) => Number(n1) - Number(n2)).filter((item, ix, items) => ix === 0 || items[ix] !== items[ix - 1]).forEach((item, ix) => {
                const n = Number(item);
                if (ix === 0 || n !== Number(items[ix - 1]) + 1) n1 = n;
                if (ix === items.length - 1 || n !== Number(items[ix + 1]) - 1) {
                    if (n1 === n) result.push(String(n));
                    else result.push(String(n1) + '-' + String(n));
                }
            });
        }
    }
    return {
        items: result,
        isErrors: isErrors,
    }
};

// Fullfill date entry.
export const fullfillDate = (txt) => {
    if (txt === null || txt === '') return txt;
    const now = new Date();
    const yr = String(now.getFullYear());
    let d = '';
    let m = '';
    let y = '';
    if (txt.indexOf('-') >= 0) {
        const parts = txt.split('-');
        d = parts[0].trim();
        m = parts.length > 1 ? parts[1].trim() : '';
        y = parts.length > 2 ? parts[2].trim() : '';
    } else {
        const trimTxt = txt.trim();
        if (/^[0-9]{2}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 1);
            m = trimTxt.substr(1, 1);
        } else if (/^[0-9]{3}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 1);
        } else if (/^[0-9]{4}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
        } else if (/^[0-9]{5}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 1);
            y = trimTxt.substr(3, 2);
        } else if (/^[0-9]{6}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
            y = trimTxt.substr(4, 2);
        } else if (/^[0-9]{7}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 1);
            y = trimTxt.substr(3, 4);
        } else if (/^[0-9]{8}$/.test(trimTxt)) {
            d = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
            y = trimTxt.substr(4, 4);
        }
    }
    if (/^[0-9]{1}$/.test(d)) d = '0' + d;
    if (/^[0-9]{1}$/.test(m)) m = '0' + m;
    if (y === '') y = yr;
    else if (/^[0-9]{2}$/.test(y)) y = yr.substr(0, 2) + y;
    if (!/^[0-9]{2}$/.test(d) || !/^[0-9]{2}$/.test(m) || !/^[0-9]{4}$/.test(y)) return 'error';
    if (!moment(d + '-' + m + '-' + y, config.formats.dateFormat, true).isValid()) return 'error';
    return d + '-' + m + '-' + y;
};

// Fullfill time entry.
export const fullfillTime = (txt, includeSeconds = false) => {
    if (txt === null || txt === '') return txt;
    let h = '';
    let m = '';
    let s = '';
    if (txt.indexOf(':') >= 0) {
        const parts = txt.split(':');
        h = parts[0].trim();
        m = parts.length > 1 ? parts[1].trim() : '';
        s = parts.length > 2 ? parts[2].trim() : '';
    } else {
        const trimTxt = txt.trim();
        if (/^[0-9]{1}$/.test(trimTxt)) {
            h = trimTxt;
        } else if (/^[0-9]{2}$/.test(trimTxt)) {
            h = trimTxt;
        } else if (/^[0-9]{3}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 1);
            m = trimTxt.substr(1, 2);
        } else if (/^[0-9]{4}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
        } else if (/^[0-9]{5}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 1);
            m = trimTxt.substr(1, 2);
            s = trimTxt.substr(3, 2);
        } else if (/^[0-9]{6}$/.test(trimTxt)) {
            h = trimTxt.substr(0, 2);
            m = trimTxt.substr(2, 2);
            s = trimTxt.substr(4, 2);
        }
    }
    if (/^[0-9]{1}$/.test(h)) h = '0' + h;
    if (m === '') m = '00';
    else if (/^[0-9]{1}$/.test(m)) m = '0' + m;
    if (s === '') s = '00';
    else if (/^[0-9]{1}$/.test(s)) s = '0' + s;
    if (!/^([0-1][0-9]|20|21|22|23)$/.test(h) || !/^[0-5][0-9]$/.test(m) || !/^[0-5][0-9]$/.test(s)) return 'error';
    return includeSeconds ? h + ':' + m + ':' + s : h + ':' + m;
};

// Default reducer merge function to combine original entity with new properties read or updated from database.
export const mergeFunction = (original, updated)=>{
    const result = Object.assign({}, original);
    for (var prop in updated) {
        if (updated.hasOwnProperty(prop)) {
            result[prop] = updated[prop];
        }
    }
    return result;
};

export const removeCommaWhitespace = string => {
    // removing all white space between a comma and any letter
    return string.replace(/\s*,\s*/g, ",")
}

export const removeNonDigits = string => {
    return string.replace(/\D/g,'')
}

export const renderDDMMYYYY = date => {
    if(date === null) return null;
    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
    return `${da}-${mo}-${ye}`;
}

export const replaceDotsWithCommas = float => {
    return float.toString().replace('.',',')
}



// WEBPACK FOOTER //
// ./src/common/src/util/lib.js